module.exports = __webpack_public_path__ + "img/cover-3.1216db55.svg";